export const ROLENAME_CREATE_ORG_CHART = 'Create-OrgChart'
export const ROLENAME_UPDATE_ORG_CHART = 'Update-OrgChart'
export const ROLENAME_VIEW_ORG_CHART = 'View-OrgChart'

export const ROLENAME_CREATE_MANAGEMENT_TEAM = 'Create-Management Structure'
export const ROLENAME_UPDATE_MANAGEMENT_TEAM = 'Update-Management Structure'
export const ROLENAME_VIEW_MANAGEMENT_TEAM = 'View-Management Structure'

export const ROLENAME_CREATE_GOVERNANCE_SETUP = 'Create-Compliance Setup'
export const ROLENAME_UPDATE_GOVERNANCE_SETUP = 'Update-Compliance Setup'
export const ROLENAME_VIEW_GOVERNANCE_SETUP = 'View-Compliance Setup'

export const ROLENAME_UPDATE_COMPLIANCE = 'Update-Manage Compliance'
export const ROLENAME_VIEW_COMPLIANCE = 'View-Manage Compliance'

export const ROLENAME_CREATE_RISK = 'Create-Risk'
export const ROLENAME_UPDATE_RISK = 'Update-Risk'
export const ROLENAME_VIEW_RISK = 'View-Risk'

export const ROLENAME_CREATE_USER_MANAGEMENT = 'Create-User Management'
export const ROLENAME_UPDATE_USER_MANAGEMENT = 'Update-User Management'
export const ROLENAME_VIEW_USER_MANAGEMENT = 'View-User Management'

export const ROLE_EXECUTIVE = 1
export const ROLE_RISK = 3
export const ROLE_COMPLIANCE = 2
export const ROLE_CHECK = 1
export const ROLE_UNCHECK = 2
